import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {BASE_CLIENT, BaseClient} from "../../client/base.client";


@Injectable({
  providedIn: "root"
})
export class UploadService {

  constructor(private http: HttpClient,
              @Inject(BASE_CLIENT) private client: BaseClient) {
  }

  /**
   * 上传
   * @param type 1：文件；2：拍照上传；3：拍照/文件 上传
   */
  uploadHandle(option: { type?: number, onOk?: (value: any) => void }) {
    const ele = document.getElementsByClassName('upt_box');
    if (ele.length > 0) {
      document.body.removeChild(ele[0]);
    }

    const input = document.createElement('input');
    input.setAttribute("type", "file");
    input.setAttribute("class", "upt_box");
    input.setAttribute("style", 'display:none');
    if (option.type == 1) {

    } else if (option.type == 2) {
      input.setAttribute("accept", "image/*");
      input.setAttribute("capture", "camera");
    } else if (option.type == 3) {
      input.setAttribute("accept", "image/*");
      input.setAttribute("mutiple", "multiple");
    }

    document.body.appendChild(input);

    input.onclick = () => {
      const inputEle = <HTMLInputElement>document.getElementsByClassName('upt_box')[0];
      inputEle.value = '';
    };
    input.click();
    input.onchange = () => {
      const file = input.files[0];
      if (option.onOk) {
        option.onOk(file);
      }
    }
  }

  /**
   * 上传文件
   * @param file
   */
  uploadFile(file: any) {
    const formData: FormData = new FormData();
    formData.set('file', file);
    return this.http.post(`${this.client.gateway}/filecenter/file`, formData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }


  /**
   * 删除文件
   * @param id 文件id
   */
  deleteFile(id: string) {
    return this.http.delete(`${this.client.gateway}/filecenter/file/${id}`).pipe(
      map((response: any) => {
        return response;
      })
    );
  }


}

